import { Component, Input, OnInit } from '@angular/core';
import { DataPointDataType, IDynamicComponentConfig } from '../../dynamic-component';
@Component({
  selector: 'app-effective-display',
  templateUrl: './effective-display.component.html',
  styles: []
})
export class EffectiveDisplayComponent implements OnInit {
  // 数据类型
  type = DataPointDataType;
  constructor() {}
  @Input() config: IDynamicComponentConfig;

  ngOnInit() {}
}
